import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { useAppSelector } from "../../../redux/hooks";

type Params = Parameters<typeof apiClient.getParentAsinPricingConfig>[0]["params"];

export const useParentAsinPricingConfig = (params: Params, options?: { enabled?: boolean }) => {
  const marketplace = useAppSelector((state) => state.marketPlace.marketPlace);
  return useQuery({
    queryKey: [{ entity: "parent_asin_pricing_config", params, marketplace }],
    queryFn: async () =>
      await apiClient.getParentAsinPricingConfig({
        params,
        queries: { marketplace },
      }),
    select: (data) => ({ ...data, by_asin: Object.groupBy(data.products, (p) => p.asin) }),
    retry: false,
    ...options,
  });
};
